import { NOTIFICATION } from "./types";

export const setAlert = (message = "", type = "", duration = 3.5) => {
  return (dispatch) => dispatch({ type: NOTIFICATION.SET, payload: { message, type, duration } });
};

export const resetAlert = () => (dispatch) => dispatch({ type: NOTIFICATION.REMOVE });
